// Get current year for footer
const currentYear = new Date().getFullYear();

export const DEFAULT_NEWSLETTER_DESIGN: any = {
  body: {
    rows: [
      {
        cells: [1],
        columns: [{
          contents: [
            {
              type: 'html',
              values: {
                html: `
                  <table width="100%" border="0" cellspacing="0" cellpadding="0" style="background-color: #1a1a1a; border-bottom: 2px solid #3f51b5; border-radius: 12px 12px 0 0;">
                    <tr>
                      <td width="80" align="center" valign="middle" style="padding: 15px 10px 15px 20px;">
                        <img src="https://www.moonskins.gg/logo512.png" alt="MoonSkins" width="48" style="display: block; border: 0; width: 48px; height: auto;" />
                      </td>
                      <td valign="middle" style="padding: 15px 20px 15px 0;">
                        <div style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 22px; font-weight: bold; color: #ffffff; letter-spacing: -0.5px;">
                          MoonSkins<span style="color: #3f51b5;">.GG</span>
                        </div>
                        <div style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 11px; color: #9ca3af; margin-top: 2px; letter-spacing: 0.5px; text-transform: uppercase;">
                          We ❤️ Skins to the 🌙 and back
                        </div>
                      </td>
                    </tr>
                  </table>
                `,
                containerPadding: '0px',
                deletable: false,
                draggable: false
              }
            }
          ]
        }]
      },
      {
        // Spacer row
        cells: [1],
        columns: [{
          contents: [
            {
              type: 'html',
              values: {
                html: `<div style="height: 20px; background-color: #262626;"></div>`,
                containerPadding: '0px'
              }
            }
          ]
        }]
      },
      {
        cells: [1],
        columns: [{
          contents: [
            {
              type: 'html',
              values: {
                html: `
                  <div style="background-color: #1a1a1a; padding: 25px; border-top: 2px solid #3f51b5; border-radius: 0 0 12px 12px ; text-align: center;">
                    <table role="presentation" border="0" cellpadding="0" cellspacing="0" align="center" style="margin: 0 auto;">
                      <tr>
                        <td style="padding: 0 8px;">
                          <a href="https://x.com/MoonSkinsGG" target="_blank"><img src="https://cdn-icons-png.flaticon.com/512/5968/5968958.png" width="18" height="18" alt="X" style="display: block; filter: invert(1);"></a>
                        </td>
                        <td style="padding: 0 8px;">
                          <a href="https://steamcommunity.com/groups/MoonSkinsGG" target="_blank"><img src="https://cdn.freebiesupply.com/images/large/2x/steam-logo-transparent.png" width="18" height="18" alt="Steam" style="display: block;"></a>
                        </td>
                        <td style="padding: 0 8px;">
                          <a href="https://instagram.com/MoonSkinsGG" target="_blank"><img src="https://cdn-icons-png.flaticon.com/512/174/174855.png" width="18" height="18" alt="Instagram" style="display: block;"></a>
                        </td>
                        <td style="padding: 0 8px;">
                          <a href="https://discord.gg/MoonSkinsGG" target="_blank"><img src="https://cdn-icons-png.flaticon.com/512/5968/5968756.png" width="18" height="18" alt="Discord" style="display: block;"></a>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 15px 0 5px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 10px; color: #6b7280; text-transform: uppercase; letter-spacing: 1px;">
                      © ${currentYear} MoonSkins.GG • All rights reserved.
                    </p>
                    <p style="margin: 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 10px;">
                      <a href="https://moonskins.gg/unsubscribe?email={{email}}&token={{token}}" style="...">
                        Unsubscribe
                      </a>                    
                    </p>
                  </div>
                `,
                containerPadding: '0px',
                deletable: false,
                draggable: false
              }
            }
          ]
        }]
      }
    ],
    values: {
      backgroundColor: '#404040',
      contentWidth: '600px',
      fontFamily: { label: 'Helvetica', value: "'Helvetica Neue', Helvetica, Arial, sans-serif" }
    }
  },
  header: {},
  footer: {},
  counters: { u_column: 1, u_row: 3, u_content_text: 1, u_content_image: 0, u_content_button: 0, u_content_divider: 1, u_content_social: 0, u_content_html: 3 },
  schemaVersion: 16
};